// this hook is needed so that on mobile devices, after opening the keyboard, the rerender is not called
export const useFixRerenderOnMobile = () => {
  if (!navigator) return;
  if ('virtualKeyboard' in navigator) {
    navigator.virtualKeyboard.overlaysContent = true;
  }
};
